const library = require('@safe-systems/ss-ui-components');

export const {
  loaderService,
  ssDialogService,
  utilityService,
} = library;

// ################################################
// DAL (aka DATA SERVICES)
// Basic API calls only.
// DO NOT put business logic in these!
// Avoid clients accessing these directly, use shared models instead.
// export { default as appDataService } from './data/app.data.service';
export { default as amDataService } from './data/am.data.service';
export { default as bcpDataService } from './data/bcp.data.service';
export { default as cmDataService } from './data/cm.data.service';
export { default as docDataService } from './data/doc.data.service';
export { default as ecatDataService } from './data/ecat.data.service';
export { default as eduDataService } from './data/edu.data.service';
export { default as emDataService } from './data/em.data.service';
export { default as importDataService } from './data/import.data.service';
export { default as orgDataService } from './data/org.data.service';
export { default as pmDataService } from './data/pm.data.service';
export { default as reportsDataService } from './data/reports.data.service';
export { default as supportDataService } from './data/support.data.service';
export { default as vmDataService } from './data/vm.data.service';
export { default as oversightDataService } from './data/oversight.data.service';
export { default as controlDataService } from './data/control.data.service';
export { default as riskDataService } from './data/risk.data.service';
export { default as assetDataService } from './data/asset.data.service';
export { default as praDataService } from './data/pra.data.service';

// ################################################
// MODELS (aka SHARED MODELS)
// Put data centric business logic here.
// DO NOT put display logic in these!
// DO NOT make API calls directly from these!
// Clients should use these instead of the DAL
export { default as amSharedModelService } from './sharedModels/am.sharedModel.service';
export { default as bcpSharedModelService } from './sharedModels/bcp.sharedModel.service';
export { default as cmSharedModelService } from './sharedModels/cm.sharedModel.service';
export { default as ecatSharedModelService } from './sharedModels/ecat.sharedModel.service';
export { default as emSharedModelService } from './sharedModels/em.sharedModel.service';
export { default as orgSharedModelService } from './sharedModels/org.sharedModel.service';
export { default as pmSharedModelService } from './sharedModels/pm.sharedModel.service';
export { default as reportsSharedModelService } from './sharedModels/reports.sharedModel.service';
export { default as supportSharedModelService } from './sharedModels/support.sharedModel.service';
export { default as theSafeSharedModelService } from './sharedModels/theSafe.sharedModel.service';
export { default as vmSharedModelService } from './sharedModels/vm.sharedModel.service';
export { default as oversightSharedModelService } from './sharedModels/oversight.sharedModel.service';
export { default as controlSharedModelService } from './sharedModels/control.sharedModel.service';
export { default as riskSharedModelService } from './sharedModels/risk.sharedModel.service';
export { default as assetSharedModelService } from './sharedModels/asset.sharedModel.service';
export { default as praSharedModelService } from './sharedModels/pra.sharedModel.service';

// ################################################
// OTHER SERVICES
export { default as appVersionService } from './appVersion.service';
export { default as authorizationService } from './membership/ss.authorization.service';
export { default as bcpUtilityService } from './bcp.utility.service';
export { default as focus } from './focus.service';
export { default as userService } from './membership/ss.user.service';

console.log('app.services loaded');
